import React, { useState } from "react";
import { searchSkill } from "../../../../../endpoints/skill.service";
import { isNullOrEmpty } from "../../../../../utils/helperFunction";

interface ReusableInputProps {
  type?: "text" | "skill" | "lastUsed" | "rating" | string;
  placeholder?: string;
  value: any;
  onChange: (val: string) => void;
  isValid?: boolean;
  options?: any;
}

const ReusableInput: React.FC<ReusableInputProps> = ({
  type = "text",
  placeholder,
  value,
  onChange,
  isValid = true,
  options = [],
}) => {
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState<any[]>([]);

  const handleTextChange = async (text: string) => {
    onChange(text);
    if (type === "skill") {
      try {
        const { success, data } = await searchSkill(text);
        if (success && data?.length > 0) {
          setSuggestions(data);
          setShowSuggestions(true);
        } else {
          setShowSuggestions(false);
        }
      } catch {
        setSuggestions([]);
        setShowSuggestions(false);
      }
    }
  };

  const suggestionItems = {
    skill: suggestions.map((item) => (
      <div
        key={item?._id}
        onClick={() => {
          onChange(item.title);
          setShowSuggestions(false);
        }}
        className="px-4 py-2 cursor-pointer hover:bg-gray-100 text-xs text-charcoal font-medium"
      >
        {item.title}
      </div>
    )),
    lastUsed: Object.keys(options)?.map((option) => (
      <div
        key={option}
        onClick={() => {
          onChange(option);
          setShowSuggestions(false);
        }}
        className="px-4 py-2 cursor-pointer hover:bg-gray-100 text-xs text-charcoal font-medium"
      >
        {option}
      </div>
    )),
  };

  return (
    <div
      className={`relative border px-3 rounded-md w-full bg-white ${
        isValid ? "border-gray-100" : "border-red-500"
      }`}
    >
      <input
        className="w-full h-9 bg-transparent text-xs font-medium outline-none"
        placeholder={placeholder}
        value={value}
        onChange={(e) => handleTextChange(e.target.value)}
        onFocus={() => setShowSuggestions(true)}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
      />

      {showSuggestions && !isNullOrEmpty(value) && suggestionItems[type] && (
        <div className="absolute top-full left-0 z-50 bg-white border border-gray-300 w-full max-h-52 overflow-y-auto shadow-md rounded-md">
          {suggestionItems[type]}
        </div>
      )}

      {type === "rating" && (
        <span className="absolute right-2 top-2.5 text-xs text-charcoal font-medium">
          /10
        </span>
      )}
    </div>
  );
};

export default ReusableInput;
